import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  USER_RESTAURANT_ACTIVITY,
  USER_OFFER_ACTIVITY,
  USER_EVENT_ACTIVITY,
  USER_ITEM_ACTIVITY,
  USER_TRACK_VIDEO,
  USER_STREAMING_ACTIVITY,
  USER_REELS_ACTIVITY,
} from "../../types";

import { setErrors } from "../errorActions";
import { serverApi } from "../../../config/Keys";
import { amApi } from "../../../api/apiHelper";

export const getUserActivity =
  (query, onSuccesGetRestaurant, onErrorrGetRestaurant) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let get_restaurant_data = await amApi.get(`/admin/misc-tracking`, {
        params: query,
      });
      if (get_restaurant_data.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type:
            query.type === 1
              ? USER_RESTAURANT_ACTIVITY
              : query.type === 2
              ? USER_OFFER_ACTIVITY
              : query.type === 3
              ? USER_EVENT_ACTIVITY
              : query.type === 4
              ? USER_ITEM_ACTIVITY 
              : query.type === 7
              ? USER_REELS_ACTIVITY
              : query.type === 6
              ? USER_TRACK_VIDEO
              : USER_STREAMING_ACTIVITY,
          payload: get_restaurant_data,
        });
      }
      onSuccesGetRestaurant();
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorrGetRestaurant();
    }
  };
